import { TCurrentUser } from '../types/user'
import { axios } from 'configs'

export const getCurrentUser = async (): Promise<TCurrentUser> => {
  const response = await axios.get<TCurrentUser>('admin/current-user')
  return response.data
}
